import { IconX } from './IconX'

export default IconX
